module.exports = __webpack_public_path__ + "static/media/logonav.7dfac36e.png";